import Vue from 'vue';
import Router from 'vue-router';

// eslint-disable-next-line import/no-cycle
import { store } from '../../store/store';
import { routes } from './routes';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = ['login', 'reset-password', 'reset-password-request', 'activate'];
  const authRequired = !publicPages.includes(to.name);
  const { loggedIn } = store.state.auth;

  if (authRequired && !loggedIn) {
    return next({ name: 'login' });
  }

  if (loggedIn && !authRequired) {
    return next({ name: 'dashboard' });
  }

  if (publicPages.includes(to.path) && loggedIn) {
    return next(from.path);
  }

  return next();
});

export { router };
